// extracted by mini-css-extract-plugin
export default {"activeSidebar":"Va-z","pageLayout":"Wa-z","mainContent":"Xa-z","columnLayout":"Ya-z","columnLayoutFill":"Za-z","columnLayoutLast":"_a-z"};